// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Dashboard — Message Stage ──────────────────────────────────────────── */

*, *::before, *::after { box-sizing: border-box; }

.db-root {
  min-height: 100vh;
  width: 100%;
  background: #0b080c;
  display: flex;
  flex-direction: column;
  font-family: inherit;
}

/* ── Navbar ──────────────────────────────────────────────────────────────── */

.db-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 22px 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.db-logo {
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.2px;
  color: rgba(240, 236, 230, 0.55);
}

.db-nav-right {
  display: flex;
  align-items: center;
  gap: 18px;
}

.db-welcome {
  font-size: 13px;
  color: rgba(240, 236, 230, 0.25);
}

.db-logout {
  background: none;
  border: none;
  font-size: 13px;
  color: rgba(240, 236, 230, 0.3);
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}

.db-logout:hover {
  color: rgba(240, 236, 230, 0.7);
}

.db-account-link {
  background: none;
  border: none;
  font-size: 13px;
  color: rgba(240, 236, 230, 0.3);
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}

.db-account-link:hover {
  color: rgba(240, 236, 230, 0.7);
}

/* ── Stage — two columns: AI preview (left), CTA (right) ───────────────────── */

.db-stage {
  flex: 1 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 64px;
  padding: 100px 32px 80px;
  min-height: 100vh;
}

.db-stage-left {
  flex: 1 1;
  max-width: 680px;
  display: flex;
  flex-direction: column;
}

.db-stage-right {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

/* ── Label ───────────────────────────────────────────────────────────────── */

.db-label {
  margin: 0 0 32px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: #c8824a;
  opacity: 0.85;
}

/* ── Bubble ──────────────────────────────────────────────────────────────── */

.db-bubble {
  max-width: 680px;
  width: 100%;
  min-height: 120px;
  padding: 40px 48px;
  background: rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 24px;
  margin-bottom: 52px;
  transition: opacity 0.5s ease;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.db-bubble--visible { opacity: 1; }
.db-bubble--hidden  { opacity: 0; }

.db-text {
  font-size: clamp(20px, 2.8vw, 28px);
  font-weight: 400;
  line-height: 1.65;
  color: #f0ece6;
  letter-spacing: -0.1px;
}

/* ── Cursor ──────────────────────────────────────────────────────────────── */

.db-cursor {
  display: inline-block;
  font-size: clamp(20px, 2.8vw, 28px);
  line-height: 1.65;
  color: #c8824a;
  margin-left: 2px;
  opacity: 0;
  transition: opacity 0.1s;
}

.db-cursor--on {
  animation: blink 0.85s step-end infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0; }
}

/* ── CTA ─────────────────────────────────────────────────────────────────── */

.db-cta {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 34px;
  background: #f0ece6;
  color: #0b080c;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.1px;
  transition: background 0.2s ease, transform 0.15s ease;
}

.db-cta:hover {
  background: #ffffff;
  transform: translateY(-2px);
}

.db-cta:active {
  transform: translateY(0);
}

.db-arrow {
  font-size: 16px;
  transition: transform 0.2s ease;
}

.db-cta:hover .db-arrow {
  transform: translateX(4px);
}

/* ── Responsive — stack the two columns on narrower screens ─────────────────── */

@media (max-width: 900px) {
  .db-stage {
    flex-direction: column;
    gap: 40px;
    padding: 90px 24px 60px;
  }

  .db-stage-left { max-width: 100%; }
}

@media (max-width: 768px) {
  .db-nav { padding: 18px 24px; }

  .db-bubble {
    padding: 28px 28px;
    border-radius: 18px;
    min-height: 90px;
  }

  .db-welcome { display: none; }
}

@media (max-width: 480px) {
  .db-nav { padding: 16px 18px; }

  .db-bubble { padding: 24px 22px; }

  .db-cta {
    padding: 13px 26px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E,yBAAyB,sBAAsB,EAAE;;AAEjD;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,+EAA+E;;AAE/E;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,iFAAiF;;AAEjF;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA,sBAAsB,UAAU,EAAE;AAClC,sBAAsB,UAAU,EAAE;;AAElC;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,+EAA+E;;AAE/E;EACE,qBAAqB;EACrB,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,YAAY,UAAU,EAAE;AAC1B;;AAEA,+EAA+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kFAAkF;;AAElF;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA,iBAAiB,eAAe,EAAE;AACpC;;AAEA;EACE,UAAU,kBAAkB,EAAE;;EAE9B;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,cAAc,aAAa,EAAE;AAC/B;;AAEA;EACE,UAAU,kBAAkB,EAAE;;EAE9B,aAAa,kBAAkB,EAAE;;EAEjC;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["/* ── Dashboard — Message Stage ──────────────────────────────────────────── */\n\n*, *::before, *::after { box-sizing: border-box; }\n\n.db-root {\n  min-height: 100vh;\n  width: 100%;\n  background: #0b080c;\n  display: flex;\n  flex-direction: column;\n  font-family: inherit;\n}\n\n/* ── Navbar ──────────────────────────────────────────────────────────────── */\n\n.db-nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  padding: 22px 48px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.db-logo {\n  font-size: 17px;\n  font-weight: 800;\n  letter-spacing: -0.2px;\n  color: rgba(240, 236, 230, 0.55);\n}\n\n.db-nav-right {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n}\n\n.db-welcome {\n  font-size: 13px;\n  color: rgba(240, 236, 230, 0.25);\n}\n\n.db-logout {\n  background: none;\n  border: none;\n  font-size: 13px;\n  color: rgba(240, 236, 230, 0.3);\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.2s;\n}\n\n.db-logout:hover {\n  color: rgba(240, 236, 230, 0.7);\n}\n\n.db-account-link {\n  background: none;\n  border: none;\n  font-size: 13px;\n  color: rgba(240, 236, 230, 0.3);\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.2s;\n}\n\n.db-account-link:hover {\n  color: rgba(240, 236, 230, 0.7);\n}\n\n/* ── Stage — two columns: AI preview (left), CTA (right) ───────────────────── */\n\n.db-stage {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 64px;\n  padding: 100px 32px 80px;\n  min-height: 100vh;\n}\n\n.db-stage-left {\n  flex: 1;\n  max-width: 680px;\n  display: flex;\n  flex-direction: column;\n}\n\n.db-stage-right {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n/* ── Label ───────────────────────────────────────────────────────────────── */\n\n.db-label {\n  margin: 0 0 32px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 2.5px;\n  text-transform: uppercase;\n  color: #c8824a;\n  opacity: 0.85;\n}\n\n/* ── Bubble ──────────────────────────────────────────────────────────────── */\n\n.db-bubble {\n  max-width: 680px;\n  width: 100%;\n  min-height: 120px;\n  padding: 40px 48px;\n  background: rgba(255, 255, 255, 0.025);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 24px;\n  margin-bottom: 52px;\n  transition: opacity 0.5s ease;\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n\n.db-bubble--visible { opacity: 1; }\n.db-bubble--hidden  { opacity: 0; }\n\n.db-text {\n  font-size: clamp(20px, 2.8vw, 28px);\n  font-weight: 400;\n  line-height: 1.65;\n  color: #f0ece6;\n  letter-spacing: -0.1px;\n}\n\n/* ── Cursor ──────────────────────────────────────────────────────────────── */\n\n.db-cursor {\n  display: inline-block;\n  font-size: clamp(20px, 2.8vw, 28px);\n  line-height: 1.65;\n  color: #c8824a;\n  margin-left: 2px;\n  opacity: 0;\n  transition: opacity 0.1s;\n}\n\n.db-cursor--on {\n  animation: blink 0.85s step-end infinite;\n}\n\n@keyframes blink {\n  0%, 100% { opacity: 1; }\n  50%       { opacity: 0; }\n}\n\n/* ── CTA ─────────────────────────────────────────────────────────────────── */\n\n.db-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  padding: 15px 34px;\n  background: #f0ece6;\n  color: #0b080c;\n  border: none;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  letter-spacing: 0.1px;\n  transition: background 0.2s ease, transform 0.15s ease;\n}\n\n.db-cta:hover {\n  background: #ffffff;\n  transform: translateY(-2px);\n}\n\n.db-cta:active {\n  transform: translateY(0);\n}\n\n.db-arrow {\n  font-size: 16px;\n  transition: transform 0.2s ease;\n}\n\n.db-cta:hover .db-arrow {\n  transform: translateX(4px);\n}\n\n/* ── Responsive — stack the two columns on narrower screens ─────────────────── */\n\n@media (max-width: 900px) {\n  .db-stage {\n    flex-direction: column;\n    gap: 40px;\n    padding: 90px 24px 60px;\n  }\n\n  .db-stage-left { max-width: 100%; }\n}\n\n@media (max-width: 768px) {\n  .db-nav { padding: 18px 24px; }\n\n  .db-bubble {\n    padding: 28px 28px;\n    border-radius: 18px;\n    min-height: 90px;\n  }\n\n  .db-welcome { display: none; }\n}\n\n@media (max-width: 480px) {\n  .db-nav { padding: 16px 18px; }\n\n  .db-bubble { padding: 24px 22px; }\n\n  .db-cta {\n    padding: 13px 26px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
